/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import Vue from 'vue';
import Vuex from 'vuex';
import UserService from '@/services/UserService';
import { setWorkstationId } from '@/services/httpHeaders';
import * as Sentry from '@sentry/vue';
// store modules
import * as localSettings from '@/store/modules/localSetting.js';
import * as localCache from '@/store/modules/localCache.js';
import * as sessionCache from '@/store/modules/sessionCache.js';
import * as snackbars from '@/store/modules/snackbars.js';
import * as pusher from '@/store/modules/pusher.ts';
import * as print from '@/store/modules/print.js';
import * as booking from '@/store/modules/booking.js';
import * as calendar from '@/store/modules/calendar.js';
import * as bookingForm from '@/store/modules/bookingForm.js';
import * as bookvisit from '@/store/modules/bookvisit.js';
import * as bookingGroup from '@/store/modules/bookingGroup.js';
import * as cancellationPolicy from '@/store/modules/cancellationPolicy.ts';
import * as customer from '@/store/modules/customer.js';
import * as invoice from '@/store/modules/invoice.js';
import * as email from '@/store/modules/email.js';
import * as map from '@/store/modules/map.js';
import * as onboarding from '@/store/modules/onboarding.ts';
import * as position from '@/store/modules/position.ts';
import * as posOrder from '@/store/modules/pos/order.ts';
import * as posCart from '@/store/modules/pos/cart.js';
import * as posCheckout from '@/store/modules/pos/checkout.js';
import * as posRegister from '@/store/modules/pos/register.js';
import * as posErrors from '@/store/modules/pos/errors.js';
import * as posReceipt from '@/store/modules/pos/receipt.js';
import * as posTerminal from '@/store/modules/pos/terminal.js';
import * as product from '@/store/modules/product.js';
import * as reservation from '@/store/modules/reservation.ts';
import * as user from '@/store/modules/user.ts';
import * as season from '@/store/modules/season.js';
import * as staticData from '@/store/modules/staticData.js';
import * as stats from '@/store/modules/stats.js';
import * as tally from '@/store/modules/tally.js';
import * as camptrac from '@/store/modules/camptrac.js';
import * as scr from '@/store/modules/scr.ts';
Vue.use(Vuex);
let authenticationInitialisationPromise = null;
export default new Vuex.Store({
    modules: {
        localSettings,
        localCache,
        sessionCache,
        snackbars,
        pusher,
        print,
        booking,
        calendar,
        bookingForm,
        bookvisit,
        bookingGroup: bookingGroup,
        cancellationPolicy,
        customer,
        invoice,
        email,
        map,
        onboarding,
        position,
        product,
        user,
        season,
        staticData,
        stats,
        tally,
        camptrac,
        scr,
        posOrder,
        posCart,
        posCheckout,
        posRegister,
        posErrors,
        posReceipt,
        posTerminal,
        reservation
    },
    state: {
        now: null,
        isOffline: false,
        currentPageName: '',
        isLoadingPage: false,
        isFetchingData: false,
        hasHardwareAccess: false,
        isElectron: false,
        isFetchingWorkstation: false,
        workstation: null,
        globalSearchString: null, // Sätt till '' för att öppna dialog
        confirmationDialog: {
            show: false,
            header: '', // obligatorisk
            body: '', // obligatorisk
            confirmationFunction: '', // string eller function, obligatorisk
            confirmationArgument: null,
            withTimer: false,
            disableCancel: false,
            requiresPin: false // pin behövs för att bekräfta
        },
        genericInputDialog: {
            show: false,
            header: '',
            prefilledValue: '',
            saveFunction: '' // string eller function, obligatorisk
        },
        vuetifyColors: [
            {
                name: 'red',
                name_sv: 'Röd',
                hex: '#F44336'
            },
            {
                name: 'pink',
                name_sv: 'Rosa',
                hex: '#E91E63'
            },
            {
                name: 'purple',
                name_sv: 'Lila',
                hex: '#9C27B0'
            },
            {
                name: 'deep-purple',
                name_sv: 'Mörkviolett',
                hex: '#673AB7'
            },
            {
                name: 'indigo',
                name_sv: 'Indigo',
                hex: '#3F51B5'
            },
            {
                name: 'blue',
                name_sv: 'Blå',
                hex: '#2196F3'
            },
            {
                name: 'light-blue',
                name_sv: 'Ljusblå',
                hex: '#03A9F4'
            },
            {
                name: 'cyan',
                name_sv: 'Cyan',
                hex: '#00BCD4'
            },
            {
                name: 'teal',
                name_sv: 'Blågrön',
                hex: '#009688'
            },
            {
                name: 'green',
                name_sv: 'Grön',
                hex: '#4CAF50'
            },
            {
                name: 'light-green',
                name_sv: 'Ljusgrön',
                hex: '#8BC34A'
            },
            {
                name: 'lime',
                name_sv: 'Lime',
                hex: '#CDDC39'
            },
            {
                name: 'yellow',
                name_sv: 'Gul',
                hex: '#FFEB3B'
            },
            {
                name: 'amber',
                name_sv: 'Bärnsten',
                hex: '#FFC107'
            },
            {
                name: 'orange',
                name_sv: 'Orange',
                hex: '#FF9800'
            },
            {
                name: 'deep-orange',
                name_sv: 'Djuporange',
                hex: '#FF5722'
            },
            {
                name: 'brown',
                name_sv: 'Brun',
                hex: '#795548'
            },
            {
                name: 'blue-grey',
                name_sv: 'Blågrå',
                hex: '#607D8B'
            },
            {
                name: 'grey',
                name_sv: 'Grå',
                hex: '#9E9E9E'
            }
        ], // OBS: detta är enum i vissa tabeller i databasen
        showUpdateDialog: false,
        updateUrl: null,
        updateType: null, // 'pwa' eller 'electron' - bestäms av serversignal eller versionsjämförelse
        electronVersion: null, // Extraherad från user agent
        triggerPinEntered: 0,
        updateSource: null, // 'forced' (server) eller 'service-worker' (bakgrundscheck)
        hasWaitingUpdate: false // Flagga för att visa uppdateringsindikator
    },
    mutations: {
        SET_IS_OFFLINE(state, val) {
            state.isOffline = val;
        },
        SET_OPEN_CONFIRMATION_DIALOG(state, val) {
            state.confirmationDialog.header = val.header;
            state.confirmationDialog.body = val.body;
            state.confirmationDialog.confirmationFunction = val.confirmationFunction;
            state.confirmationDialog.confirmationArgument = val.confirmationArgument ?? null;
            state.confirmationDialog.withTimer = val.withTimer ?? false;
            state.confirmationDialog.disableCancel = val.disableCancel ?? false;
            state.confirmationDialog.requiresPin = val.requiresPin ?? false;
            state.confirmationDialog.show = true;
        },
        SET_CLOSE_CONFIRMATION_DIALOG(state) {
            state.confirmationDialog.show = false;
            state.confirmationDialog.header = '';
            state.confirmationDialog.body = '';
            state.confirmationDialog.confirmationFunction = '';
            state.confirmationDialog.confirmationArgument = null;
            state.confirmationDialog.withTimer = false;
            state.confirmationDialog.disableCancel = false;
            state.confirmationDialog.requiresPin = false;
            state.confirmationDialog.enforcesPin = false;
        },
        SET_TRIGGER_PIN_ENTERED(state) {
            state.triggerPinEntered++;
        },
        SET_OPEN_GENERIC_INPUT_DIALOG(state, val) {
            state.genericInputDialog.header = val.header ?? '';
            state.genericInputDialog.saveFunction = val.saveFunction;
            state.genericInputDialog.prefilledValue = val.prefilledValue ?? '';
            state.genericInputDialog.show = true;
        },
        SET_CLOSE_GENERIC_INPUT_DIALOG(state) {
            state.genericInputDialog.show = false;
            state.genericInputDialog.header = '';
            state.genericInputDialog.saveFunction = '';
            state.genericInputDialog.prefilledValue = '';
        },
        SET_SHOW_UPDATE_DIALOG(state, val) {
            state.showUpdateDialog = val;
        },
        SET_UPDATE_URL(state, val) {
            state.updateUrl = val;
        },
        SET_UPDATE_TYPE(state, val) {
            state.updateType = val;
        },
        SET_UPDATE_SOURCE(state, val) {
            if (state.updateSource === 'forced' && val === 'service-worker') {
                // Don't downgrade from forced to service-worker
                return;
            }
            state.updateSource = val;
        },
        SET_HAS_WAITING_UPDATE(state, val) {
            state.hasWaitingUpdate = val;
        },
        SET_ELECTRON_VERSION(state, val) {
            state.electronVersion = val;
        },
        SET_CURRENT_PAGE_NAME(state, val) {
            state.currentPageName = val;
        },
        SET_IS_LOADING_PAGE(state, val) {
            state.isLoadingPage = val;
        },
        SET_IS_FETCHING_DATA(state, val) {
            state.isFetchingData = val;
        },
        SET_HAS_HARDWARE_ACCESS(state, val) {
            state.hasHardwareAccess = val;
        },
        SET_IS_ELECTRON(state, val) {
            state.isElectron = val;
        },
        SET_GLOBAL_SEARCH_STRING(state, val) {
            state.globalSearchString = val;
        },
        SET_WORKSTATION(state, val) {
            localStorage.setItem('AUTH_WORKSTATION', JSON.stringify(val));
            if (window.hardware) {
                window.hardware.setConfig('AUTH_WORKSTATION', JSON.stringify(val));
            }
            if (val && val.machine_id) {
                // skriver över med machine_id som kommer från server, likaså accepterar server förslag på befintliga maskinid som skickas in
                localStorage.setItem('AUTH_MACHINE_ID', val.machine_id);
                if (window.hardware) {
                    window.hardware.setConfig('AUTH_MACHINE_ID', val.machine_id);
                }
            }
            state.workstation = val;
            setWorkstationId(val?.id);
            Sentry.setTag('workstation_id', val?.id);
        }
    },
    actions: {
        initialiseStore({ dispatch, commit }, { initialiseAuthentication = true } = {}) {
            commit('SET_IS_OFFLINE', !window.navigator.onLine);
            window.addEventListener('offline', function () {
                commit('SET_IS_OFFLINE', true);
            });
            window.addEventListener('online', function () {
                commit('SET_IS_OFFLINE', false);
            });
            const userAgent = navigator.userAgent.toLowerCase();
            const isElectron = userAgent.indexOf(' electron/') > -1;
            commit('SET_IS_ELECTRON', isElectron);
            // Extrahera electron-version från user agent (format: campingonline/x.x.x)
            if (isElectron) {
                const electronVersionMatch = userAgent.match(/campingonline\/([0-9.]+)/);
                if (electronVersionMatch && electronVersionMatch[1]) {
                    commit('SET_ELECTRON_VERSION', electronVersionMatch[1]);
                }
            }
            const hasHardwareAccess = !!window.hardware;
            commit('SET_HAS_HARDWARE_ACCESS', hasHardwareAccess);
            dispatch('localSettings/initialise');
            dispatch('localCache/initialise');
            dispatch('sessionCache/initialise');
            if (initialiseAuthentication) {
                dispatch('initialiseAuthentication');
            }
        },
        initialiseAuthentication({ dispatch }) {
            if (!authenticationInitialisationPromise) {
                authenticationInitialisationPromise = dispatch('user/initialise')
                    .catch(error => {
                    authenticationInitialisationPromise = null;
                    throw error;
                });
            }
            return authenticationInitialisationPromise;
        },
        fetchWorkstation({ commit, dispatch }) {
            const machineId = (window.hardware && window.hardware.getConfig('AUTH_MACHINE_ID')) || localStorage.getItem('AUTH_MACHINE_ID');
            const hostname = window.hardware?.hostname || '';
            return UserService.getWorkstation({ machineId, hostname })
                .then(({ data }) => {
                commit('SET_WORKSTATION', data.data.workstation);
                if (data.data.user) {
                    commit('user/SET_USER', data.data.user, { root: true });
                }
            })
                .finally(() => {
                dispatch('pusher/subscribeWorkstationUpdated', undefined, { root: true });
            });
        },
        fetchData({ commit, dispatch }, { quickly = false }) {
            // Initialisering som kräver authentisering först, startas från user module
            commit('SET_IS_FETCHING_DATA', true);
            let seconds = 4.8;
            if (process.env.NODE_ENV === 'development' || quickly) {
                seconds = 0;
            }
            const finishFirstAt = window.dayjs.now().add(seconds, 'seconds');
            // OBS: Tänk på att alla actions nedan behöver returnera en promise om svaret ska inväntas
            // VIKTIGT: saker som syncas med pusher ska läggas till också i resync action i pusher.js, så det hämtas om vid anslutningsproblem
            Promise.allSettled([
                /* syncas med pusher */ dispatch('fetchWorkstation') // Behöver köras innan övriga för att ha rätt workstation header satt
            ])
                .then(([workstationResult]) => {
                if (workstationResult.status === 'rejected' && workstationResult.reason?.isAxiosError && workstationResult.reason.response === undefined) {
                    // Servern svarade inte vid uppstart (GET har redan försökts igen i API-interceptorn). Gå till låsskärmen
                    // istället för att visa appen utan data. Interceptorn låser inte längre själv vid nätverksfel.
                    dispatch('user/deactivateAuthSession');
                    return;
                }
                Promise.allSettled([
                    // OBS: undvika för många parallella requests
                    dispatch('staticData/fetchStaticData'),
                    dispatch('position/fetchMap'), // Laddar bara in bilden, hämtar inget från server
                    dispatch('invoice/fetchPaymentTerms'),
                    dispatch('posCheckout/fetchPaymentMethods'),
                    dispatch('cancellationPolicy/fetchCancellationPolicies'),
                    dispatch('posRegister/fetchRegister'),
                    dispatch('product/fetchProducts'), // Hämtar också product groups och layout tabs
                    dispatch('season/fetchSeasons'),
                    /* remarks syncas med pusher */ dispatch('position/fetchCategoriesAndPositions'),
                    /* syncas med pusher */ dispatch('booking/fetchBookings'),
                    /* syncas med pusher */ dispatch('posOrder/fetchOrders'),
                    /* syncas med pusher */ dispatch('tally/fetchCards'), // Körs bara om campingen använder Tally
                    /* syncas med pusher */ dispatch('camptrac/fetchCards'), // Körs bara om campingen använder CampTrac
                    /* syncas med pusher */ dispatch('stats/fetchDashboards')
                ])
                    .then(() => {
                    Promise.allSettled([
                        dispatch('position/enrichPositions'),
                        dispatch('position/enrichCategories'),
                        dispatch('staticData/enrichCountries'),
                        dispatch('booking/enrichBookings', { seasonBookingsOnly: false }),
                        dispatch('posOrder/enrichOrders'),
                        dispatch('product/enrichProducts'),
                        dispatch('product/enrichProductGroups'),
                        dispatch('product/enrichProductLayoutTabs')
                    ])
                        .finally(() => {
                        // Visar laddningssidan minimum 4.8 sek
                        const diff = finishFirstAt.diff(window.dayjs.now(), 'ms');
                        if (diff < 0) {
                            commit('SET_IS_FETCHING_DATA', false);
                            dispatch('booking/startActionItemsSyncDiagnostics');
                        }
                        else {
                            setTimeout(() => {
                                commit('SET_IS_FETCHING_DATA', false);
                                dispatch('booking/startActionItemsSyncDiagnostics');
                            }, diff);
                        }
                        // Låg prio requests
                        // Requests som ska köras vid uppstart, men kan köras efter laddningsskärmen, och inte är beroende av enrichment
                        dispatch('scr/fetchStatus');
                        /* syncas med pusher */ dispatch('bookvisit/fetchUnresolvedFailedSyncs');
                    });
                });
            });
            dispatch('season/fetchCalendarDates'); // Behöver inte invänta svar
            dispatch('pusher/initialise', { force: false });
        },
        refreshNow({ state }) {
            state.now = window.dayjs.now();
        },
        navigated({ commit }, route) {
            commit('SET_CURRENT_PAGE_NAME', route.to.name);
            window.scannerVM?.setCurrentPageName(route.to.name);
        },
        updateClient({ state }) {
            window.hardware?.updateClient(state.updateUrl);
        },
        closeDialogs({ commit, dispatch }) {
            commit('invoice/SET_SHOW_DIALOG', false);
            commit('booking/SET_SHOW_DIALOG', false);
            commit('bookingGroup/SET_SHOW_DIALOG', false);
            dispatch('bookingForm/setShowFormDialog', false);
            commit('customer/SET_SHOW_DIALOG', false);
            commit('reservation/CLOSE_DIALOG');
            commit('reservation/CLOSE_ITEM_DIALOG');
            commit('reservation/CLOSE_PRODUCT_DIALOG');
            commit('reservation/CLOSE_PRODUCT_EDIT_DIALOG');
            commit('posReceipt/SET_SHOW_DIALOG', false);
            commit('SET_GLOBAL_SEARCH_STRING', null); // stänger sökdialogen
            commit('product/SET_SHOW_DIALOG', false);
            commit('product/SET_SHOW_PRODUCT_GROUP_DIALOG', false);
        }
    },
    getters: {}
});
